import clsx from 'clsx'
import {CrudProvider} from '../../../../../services/loggedin/CrudContext'
import {FormComponent} from '../../../../parts/crud/Form'
import {useIntl} from 'react-intl'
import Select from 'react-select'
import {Form} from 'react-bootstrap'
import {useEffect, useState} from 'react'
import {useLang} from '../../../../../_metronic/i18n/Metronici18n'
import {NoAlarmReturn} from './params/NoAlarmReturn'
import {AggregateSimilarEvents} from './params/AggregateSimilarEvents'
import {AllEvents} from './params/AllEvents'
import {SelectedKeyWord} from './params/SelectedKeyWord'
import { processGet } from '../../../../../services/api'
import { Navigate, useParams } from 'react-router-dom'
export const EventSubscriptionForm = () => {
  const [redirect, setRedirect] = useState('')
    const {id} = useParams()
    console.log('id', id)
  useEffect(() => {

    async function getCount() {
      if(id !==  undefined){
        return
      }
      let data: any = await processGet('system-settings/event-subscription/count')
      if(data.data.items >= 20){
        setRedirect('/system-settings/event-subscription')
      }
    }
    getCount()
  }
  , []);
  const intl = useIntl()
  return (
    <>
    {redirect && <Navigate to={redirect} />}  
      <CrudProvider api='system-settings/event-subscription'>
        <FormComponent
          fetch={{
            channels: 'system-settings/event-subscription/channel-types',
            analysis: 'system-settings/event-subscription/analysis-types',
            eventsCategories: 'system-settings/event-subscription/event-categories',
            servers: 'system-settings/event-subscription/servers',
            devices: 'system-settings/event-subscription/devices',
          }}
          redirect='/system-settings/event-subscription'
          text_modificato={intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.EDITED'})}
          text_nuovo={intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.CREATED'})}
        >
          {(formik, data, remoteErrors, isEdit, otherError) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-12'>
                  <label htmlFor='fk_eventcat' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.EVENT_CATEGORY'})}
                  </label>
                  <Select
                    name='fk_eventcat'
                    options={data.eventsCategories.map((cat: any) => ({
                      value: cat.event_enumerator_code,
                      label: cat.eventcat_description,
                    }))}
                    className={clsx('basic-multi-select ', {
                      'is-invalid':
                        (formik.touched.fk_eventcat && formik.errors.fk_eventcat) ||
                        remoteErrors.fk_eventcat !== undefined,
                      'is-valid':
                        formik.touched.fk_eventcat &&
                        !formik.errors.fk_eventcat &&
                        remoteErrors !== undefined &&
                        remoteErrors.fk_eventcat === undefined,
                    })}
                    classNamePrefix='select'
                    onChange={(selectedOption) => {
                      formik.setFieldValue('fk_eventcat', selectedOption)
                    }}
                    value={formik.values.fk_eventcat}
                  />
                  {formik.touched.fk_eventcat && formik.errors.fk_eventcat ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.fk_eventcat},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.EVENT_CATEGORY',
                          }),
                        }
                      )}
                    </em>
                  ) : null}

                  {otherError.fk_eventcat ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {
                          id:
                            typeof otherError.fk_eventcat === 'string'
                              ? otherError.fk_eventcat
                              : otherError.fk_eventcat.error,
                        },
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.EVENT_CATEGORY',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>
              <div className='row mb-6'>
                <div className='col-md-12'>
                  <label htmlFor='fk_eventcat' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.CHANNEL_TYPE'})}
                  </label>
                  <Channels
                    onChannelsChanged={(channels: any) =>
                      formik.setFieldValue('channels', channels)
                    }
                    data={formik.values.channels}
                    channels={data.channels}
                  />

                  {otherError.channels ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {
                          id:
                            typeof otherError.channels === 'string'
                              ? otherError.channels
                              : otherError.channels.error,
                        },
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.CHANNEL_TYPE',
                          }),
                          channel:
                            typeof otherError.channels === 'string'
                              ? ''
                              : otherError.channels.channel,
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-6'>
                  <label htmlFor='servers' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.SERVERS'})}
                  </label>
                  <Select
                    isMulti
                    name='servers'
                    options={data.servers.map((cat: any) => ({
                      value: cat.id,
                      label: cat.serverDescription,
                    }))}
                    className={clsx('basic-multi-select ', {
                      'is-invalid':
                        (formik.touched.servers && formik.errors.servers) ||
                        remoteErrors.servers !== undefined,
                      'is-valid':
                        formik.touched.servers &&
                        !formik.errors.servers &&
                        remoteErrors !== undefined &&
                        remoteErrors.servers === undefined,
                    })}
                    classNamePrefix='select'
                    onChange={(selectedOption) => {
                      formik.setFieldValue('servers', selectedOption)
                    }}
                    value={formik.values.servers}
                  />
                  {formik.touched.servers && formik.errors.servers ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.servers},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.SERVERS',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>

                <div className='col-md-6'>
                  <label htmlFor='analysisTypes' className='required fw-bold fs-6'>
                    {intl.formatMessage({id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.SELECT_ANALYSIS_TYPE'})}
                  </label>
                  <Select
                    name='analysisTypes'
                    options={data.analysis.map((cat: any) => ({
                      value: cat.analysis_type_code,
                      label: intl.formatMessage({id:cat.analysis_type}),
                    }))}
                    className={clsx('basic-multi-select ', {
                      'is-invalid':
                        (formik.touched.analysisTypes && formik.errors.analysisTypes) ||
                        remoteErrors.analysisTypes !== undefined,
                      'is-valid':
                        formik.touched.analysisTypes &&
                        !formik.errors.analysisTypes &&
                        remoteErrors !== undefined &&
                        remoteErrors.analysisTypes === undefined,
                    })}
                    classNamePrefix='select'
                    onChange={(selectedOption) => {
                      formik.setFieldValue('analysisTypes', selectedOption)
                    }}
                    value={formik.values.analysisTypes}
                  />
                  {formik.touched.analysisTypes && formik.errors.analysisTypes ? (
                    <em className='text-danger'>
                      {intl.formatMessage(
                        {id: formik.errors.analysisTypes},
                        {
                          field: intl.formatMessage({
                            id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.EVENT_CATEGORY',
                          }),
                        }
                      )}
                    </em>
                  ) : null}
                </div>
              </div>

              <div className='row mb-6'>
                {formik.values.analysisTypes !== '' &&
                  formik.values.analysisTypes.value !== undefined &&
                  formik.values.analysisTypes.value === 'no_alarm_return' && (
                    <NoAlarmReturn
                      data={data}
                      params={formik.values.params}
                      onChange={(e: any) => {
                        formik.setFieldValue('params', e)
                      }}
                    />
                  )}

                {formik.values.analysisTypes !== '' &&
                  formik.values.analysisTypes.value !== undefined &&
                  formik.values.analysisTypes.value === 'occurrencies_in_timeframe' && (
                    <AggregateSimilarEvents
                      data={data}
                      params={formik.values.params}
                      onChange={(e: any) => {
                        formik.setFieldValue('params', e)
                      }}
                    />
                  )}

                {formik.values.analysisTypes !== '' &&
                  formik.values.analysisTypes.value !== undefined &&
                (formik.values.analysisTypes.value === 'realtime' ||  formik.values.analysisTypes.value === 'realtime_return') && (
                    <AllEvents
                      data={data}
                      params={formik.values.params}
                      onChange={(e: any) => {
                        formik.setFieldValue('params', e)
                      }}
                    />
                  )}
                {formik.values.analysisTypes !== '' &&
                  formik.values.analysisTypes.value !== undefined &&
                  formik.values.analysisTypes.value === 'keyword' && (
                    <SelectedKeyWord
                      data={data}
                      params={formik.values.params}
                      onChange={(e: any) => {
                        formik.setFieldValue('params', e)
                      }}
                    />
                  )}

                {otherError.params ? (
                  <em className='text-danger'>
                    {intl.formatMessage({
                      id:
                        typeof otherError.params === 'string'
                          ? otherError.params
                          : otherError.params.error,
                    })}
                  </em>
                ) : null}
              </div>
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}

const Channels = ({channels, onChannelsChanged, data}: any) => {

  const [selectedChannels, setSelectedChannels] = useState<any>(data)

  const changedChannel = (channel: any, data: any) => {
    if (!data.enabled) {
      if (
        selectedChannels.findIndex(
          (c: any) => c.channel_type_code === channel.channel_type_code
        ) !== -1
      ) {
        setSelectedChannels(
          selectedChannels.filter((c: any) => c.channel_type_code !== channel.channel_type_code)
        )
      }
    } else {
      if (
        selectedChannels.findIndex(
          (c: any) => c.channel_type_code === channel.channel_type_code
        ) === -1
      ) {
        setSelectedChannels([...selectedChannels, data])
      } else {
        setSelectedChannels(
          selectedChannels.map((c: any) =>
            c.channel_type_code === channel.channel_type_code ? data : c
          )
        )
      }
    }
  }
  useEffect(() => {
    if(data.length > 0){
      setSelectedChannels(data)
    }
  }
  , [data]);

  useEffect(() => {
    onChannelsChanged(selectedChannels)
    console.log('selectedChannels', selectedChannels)
  }, [selectedChannels]);
  

  console.log('data', data)
  console.log('selectedChannels', selectedChannels)
  return (
    <>
      {channels.map((channel: any) => (
        <Channel
          onChannelChanged={changedChannel}
          channel={channel}
          key={channel.channel_type_code}
          _enabled={selectedChannels.findIndex(
            (c: any) => c.channel_type_code === channel.channel_type_code
          ) !== -1}
          _channelValue={selectedChannels.find(
            (c: any) => c.channel_type_code === channel.channel_type_code
          )?.channelValue}
          _lancguage={selectedChannels.find(
            (c: any) => c.channel_type_code === channel.channel_type_code
          )?.language}
        />
      ))}
    </>
  )
}

const Channel = ({channel, onChannelChanged,_enabled,_channelValue,_lancguage}: any) => {
  console.log("_enabled",_enabled)
  const locale = useLang()
  const intl = useIntl()
  let lang = _lancguage ? _lancguage : (locale=="it"?"italian":"english")
  _channelValue = _channelValue ? _channelValue : ''
  const [enabled, setEnabled] = useState(_enabled)
  const [language, setLanguage] = useState(lang)
  const [channelValue, setChannelValue] = useState(_channelValue+'')
  useEffect(() => {
    const ch = {
      enabled,
      language,
      channelValue,
      channel_type_code: channel.channel_type_code,
    }
    onChannelChanged(channel, ch)
  }, [channelValue, enabled, language])
  return (
    <>
      <div className='row mb-6'>
        <div className='col-md-1'>
          <Form.Check // prettier-ignore
            type='switch'
            id='custom-switch'
            className='mt-4'
            checked={enabled}
            onChange={() => setEnabled(!enabled)}
            label={channel.channel_type}
          />
        </div>
        <div className='col-md-8'>
          <input
            disabled={!enabled}
            type='text'
            placeholder={channel.channel_type_code == 'telegram' ? 'Channels ID' : intl.formatMessage({id: 'GENEIRC.RECIPIENT'})}
            value={channelValue}
            onChange={(e) => setChannelValue(e.target.value)}
            className='form-control'
          />
        </div>
        <div className='col-md-3'>
          <select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            disabled={!enabled}
            className='form-select'
          >
            <option value='english'>English</option>
            <option value='italian'>Italiano</option>
            <option value='spanish'>Español</option>
            <option value='portuguese'>Português</option>
          </select>
        </div>
      </div>
    </>
  )
}
